
  (function () {
    const mfKey = '__module_federation__containers';
    window[mfKey] = window[mfKey] || {};
    window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'] = window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'] || {
      get: async (cmpId) => {
        const importFn = window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'][cmpId];
        const Component = await importFn();
        return () => Component;
      },
      init: async () => {
        
      },
    };

    window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362']['2fbbd7b8-2d0a-4e26-8a02-350e8083557e'] = () => import('/src/dashboard/pages/faire-products/page.tsx');
  })();